export default __webpack_public_path__ + "static/2287-4d935142aa71ffdabad5e81671ade7f2.gif";